<div class="card mb-0">
  <div class="card-header">
    <h4 class="card-title">
      @if (edit) {
        {{'cuenta.editarCliente' | translate}}
      }
      @if (!edit) {
        {{'cuenta.nuevoCliente' | translate}}
      }
    </h4>
  </div>
  <div class="card-body mb-0">
    <div class="form" [formGroup]="form">
      <div class="flex-box row row-col-gap mb-1" data-gutter="0">
        <div class="col-md-2">
          <label class="inline-label icheck-label _ml-20">
            <span class="icheck-title">
              <input class="ng-valid ng-dirty ng-touched" (click)="changeTypeDocument(1)" name="typeDocumentRadio"
                type="radio" [checked]="form.get('typeDocument').value == 1" ng-reflect-model="true" />
                RUT
              </span>
            </label>
          </div>
          <div class="col-md-6">
            <label class="inline-label icheck-label _ml-20">
              <span class="icheck-title">
                <input class="ng-valid ng-dirty ng-touched" (click)="changeTypeDocument(2)" name="typeDocumentRadio"
                  type="radio" [checked]="form.get('typeDocument').value == 2" ng-reflect-model="true" />
                  {{'tarjeta_pago.pasaporte' | translate}}
                </span>
              </label>
            </div>
          </div>

          <div class="mb-1">
            <label class="form-label">
              @if (form.get('typeDocument').value == 1) {
                {{'cuenta.rut' | translate}}
              } @else {
                {{'tarjeta_pago.pasaporte' | translate}}
              }
            </label>
            @if (form.get('typeDocument')?.value == 1) {
              <div class="theme-payment-page-form-item form-group">
                <input formControlName="rut" class="form-control" type="text"
                  placeholder="{{'cuenta.ingreseIndentificacion' | translate}}" rut maxlength="13"/>
                  @if (
                    form &&
                    form.controls['rut'].hasError('required') &&
                    form.controls['rut'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span></label>
                  }
                  @if (
                    form &&
                    form.controls['rut'].hasError('customError') &&
                    form.controls['rut'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'anulaciones.rutInvalido' | translate}}</span></label>
                  }
                  @if (
                    form &&
                    form.controls['rut'].hasError('minlength') &&
                    form.controls['rut'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'anulaciones.minimoDigitos' | translate}}</span></label>
                  }
                  @if (
                    form &&
                    form.controls['rut'].hasError('maxlength') &&
                    form.controls['rut'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.maximo_digitos12' | translate}}</span></label>
                  }
                </div>
              } @else {
                <input formControlName="rut" class="form-control" type="text" thousandSeparator="."
                  placeholder="{{'cuenta.ingreseIndentificacion' | translate}}" />
                  @if (
                    form &&
                    form.controls['rut'].hasError('required') &&
                    form.controls['rut'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span>
                  </label>
                }
                @if (
                  form &&
                  form.controls['rut'].hasError('minlength') &&
                  form.controls['rut'].touched
                  ) {
                  <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.minimoDigitos4' | translate}}</span>
                </label>
              }
              @if (
                form &&
                form.controls['rut'].hasError('maxlength') &&
                form.controls['rut'].touched
                ) {
                <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.maximo_digitos15' | translate}}</span>
              </label>
            }
          }
        </div>

        <div class="mb-1">
          <label class="form-label">{{'tarjeta_pago.nombre' | translate}}</label>
          <div class="theme-payment-page-form-item form-group">
            <input formControlName="firstname" class="form-control form-control-alterado" type="text"
              placeholder="{{'tarjeta_pago.nombre' | translate}}" />
              @if (
                form &&
                form.controls['firstname'].hasError('required') &&
                form.controls['firstname'].touched
                ) {
                <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span></label>
              }
              @if (
                form &&
                form.controls['firstname'].hasError('pattern') &&
                form.controls['firstname'].touched
                ) {
                <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.soloAlfanumericos' | translate}}</span></label>
              }
            </div>
          </div>

          <div class="mb-1">
            <label class="form-label">{{'tarjeta_pago.apellido' | translate}}</label>
            <div class="theme-payment-page-form-item form-group">
              <input formControlName="lastname" class="form-control form-control-alterado" type="text"
                placeholder="{{'tarjeta_pago.apellido' | translate}}" />
                @if (
                  form &&
                  form.controls['lastname'].hasError('required') &&
                  form.controls['lastname'].touched
                  ) {
                  <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span></label>
                }
                @if (
                  form &&
                  form.controls['lastname'].hasError('pattern') &&
                  form.controls['lastname'].touched
                  ) {
                  <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.soloAlfanumericos' | translate}}</span></label>
                }
              </div>
            </div>

            <div class="mb-1">
              <label class="form-label">{{'tarjeta_pago.correo' | translate}}</label>
              <div class="theme-payment-page-form-item form-group">
                <input formControlName="email" class="form-control form-control-alterado" type="text"
                  placeholder="peter@example.com" />
                  @if (
                    form &&
                    form.controls['email'].hasError('required') &&
                    form.controls['email'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span></label>
                  }
                  @if (
                    form &&
                    form.controls['email'].hasError('email') &&
                    form.controls['email'].touched
                    ) {
                    <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.correo_invalido' | translate}}</span></label>
                  }
                </div>
              </div>

              <div class="mb-1">
                <label class="form-label">{{'tarjeta_pago.telefono' | translate}}</label>
                <div class="theme-payment-page-form-item form-group">
                  <input formControlName="phone" class="form-control form-control-alterado" type="text"
                    placeholder="95805XXXX" />
                    @if (
                      form &&
                      form.controls['phone'].hasError('required') &&
                      form.controls['phone'].touched
                      ) {
                      <label class="err-label icheck-label"><span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span></label>
                    }
                    @if (
                      form &&
                      form.controls['phone'].hasError('pattern') &&
                      form.controls['phone'].touched
                      ) {
                      <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.ingreseNumeros' | translate}}</span></label>
                    }
                    @if (
                      form &&
                      form.controls['phone'].hasError('minlength') &&
                      form.controls['phone'].touched
                      ) {
                      <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.debeTener9' | translate}}</span></label>
                    }
                    @if (
                      form &&
                      form.controls['phone'].hasError('maxlength') &&
                      form.controls['phone'].touched
                      ) {
                      <label class="err-label icheck-label"><span class="icheck-title">{{'cuenta.noDebeTener9' | translate}}</span></label>
                    }
                  </div>
                </div>

                <div class="mb-1">
                  <label class="form-label">{{'cuenta.ciudad' | translate}}</label>
                  <div class="theme-payment-page-form-item form-group">
                    <ng-select (click)="cambiarCiudad()" [items]="cities" bindLabel="city" placeholder="{{'cuenta.seleccioneCiudad' | translate}}"
                      formControlName="city">
                    </ng-select>
                    @if (form && form.controls['city'].hasError('required') && form.controls['city'].touched) {
                      <label
                        class="err-label icheck-label">
                        <span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span>
                      </label>
                    }
                  </div>

                  <div class="mb-1">
                    <label class="form-label">{{'cuenta.nacionalidad' | translate}}</label>
                    <div class="theme-payment-page-form-item form-group">
                      <ng-select [items]="countries" bindLabel="country" placeholder="{{'cuenta.seleccioneNacionalidad' | translate}}"
                        formControlName="nationalidad">
                      </ng-select>
                      @if (
                        form &&
                        form.controls['nationalidad'].hasError('required') &&
                        form.controls['nationalidad'].touched
                        ) {
                        <label class="err-label icheck-label">
                          <span class="icheck-title">{{'tarjeta_pago.requerido' | translate}}</span>
                        </label>
                      }
                    </div>
                  </div>
                  <div class="text-center">
                    @if (err) {
                      <p class="err-message">{{ err }}</p>
                    }
                    <button (click)="save()" class="btn btn-primary waves-effect waves-float waves-light">
                      @if (edit) {
                        {{'cuenta.modificarPasajero' | translate}}
                      }
                      @if (!edit) {
                        {{'cuenta.crearPasajero' | translate}}
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
